/**
 * @fileoverview Shared configuration constants for the Period Calculator.
 * Contains phase definitions, colors, storage keys, and default values.
 * @module period-tracker/period-config
 */

/* global femcare */

femcare.periodTracker = femcare.periodTracker || {};

/**
 * @namespace femcare.periodTracker.config
 * @description Shared configuration for all period tracker modules.
 */
femcare.periodTracker.config = {
    /**
     * Default cycle configuration values.
     */
    defaults: {
        menstrualDuration: 5,
        menstrualCycle: 28,
        monthsToCalculate: 12,
        warningThresholdMonths: 6
    },

    /**
     * Fixed phase day ranges within a cycle.
     */
    phaseDays: {
        menstruation: 5,
        follicular: 5,
        ovulation: 5,
        luteal: 13
    },

    /**
     * Phase background colors for day numbers.
     */
    phaseColors: {
        menstruation: '#DA291C',
        follicular: '#D4D4F0',
        ovulation: '#D0E6E5',
        luteal: '#F6EEEC'
    },

    /**
     * Phase ring segment colors.
     */
    phaseRingColors: {
        menstruation: '#F6EEEC',
        follicular: '#F6EEEC',
        ovulation: '#F6EEEC',
        luteal: '#F6EEEC'
    },

    /**
     * Session storage keys.
     */
    storageKeys: {
        tooltipSeen: 'pcv3_results_tooltip_seen'
    },

    /**
     * Animation and timing values.
     */
    timing: {
        tooltipDelay: 300,
        scrollDelay: 300,
        tooltipAfterScroll: 500
    },

    /**
     * CSS selectors used across modules.
     */
    selectors: {
        wrapper: '.period-calendar__wrapper',
        circularView: '#circular-view',
        calendarView: '#calendar-view',
        navigation: '.navigation',
        tooltip: '#period-calendar-tooltip'
    }
};
